import React from 'react'
import { Grid, GridItem } from 'components/Grid'
import moment from 'moment';
import Button from 'components/Button';
import './WidgetSuccess.scss';
import GTM from '../../../../utils/GTM';


class WidgetSuccess extends React.Component {
    handleCopy = () => {
        this.link.select()
        document.execCommand('copy')
        GTM.dispatch(GTM.EVENT_SHARE_LINK)
    }

    render() {
        const { request, success_message } = this.props
        const fields = request.custom_fields.map(field => (
            <p><span className={`icon ${field.icon}`} /> {field.value}</p>
        ))
        fields.unshift((
            <p><span className="icon icon-clock" /> {moment(request.date).format('HH:mm')}</p>
        ))
        fields.unshift((
            <p><span className="icon icon-calendar-full" /> {moment(request.date).format('DD/MM/YYYY')}</p>
        ))
        fields.unshift((
            <p><span className="icon icon-map-marker" /> {request.adventure.title}</p>
        ))

        return (
            <div className="WidgetSuccess">
                <h2><span className="fa fa-check" />Seu horário foi reservado!</h2>
                {!!success_message && <div className="wrapper text-left clear-inner reset-text" dangerouslySetInnerHTML={{ __html: success_message }}></div>}
                <div className="wrapper">
                    <p>Convide seus amigos compartilhando este link com as informações sobre a reserva:</p>
                    <div className='copy-div'>
                        <input ref={(link) => this.link = link} type="text" value={request.short_url} onFocus={this.handleCopy} />
                        <Button size='lg' type='primary' onClick={() => this.link.focus()}>Copiar</Button>
                    </div>

                </div>
                <div className="infos">
                    <Grid style={{ width: '80%', margin: 'auto' }}>
                        {fields.map((field, i) => (
                            <GridItem key={i} lg={4} md={4} sm={4} xs={4}>
                                {field}
                            </GridItem>
                        ))}
                    </Grid>
                </div>
            </div>
        )
    }
}

export default WidgetSuccess
